import { Button, ButtonText } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Pressable } from "@/components/ui/pressable";
import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Image } from "@/components/ui/image";
import React from 'react';

import { IconM } from '@/components/media/IconsV2';

import * as assets_images from '../../../assets/images';

export const ContactPatternAside = ({ aside }) => {
  return (
    <VStack className="bg-secondary-50 flex-1 px-3">
      {/* profile */}
      <VStack className="flex-none pt-12 items-center">
        <Image key={aside.media} source={aside.media} resizeMode='cover' fallbackSource={assets_images.placeholderImg} className="w-[200px] h-[200px] rounded-[50%] border-primary-900 border-[2px]" />
        <Text isTruncated={true} className="mt-6 text-xl font-[700] text-secondary-900">{aside.title}</Text>
        <Text isTruncated={true} className="mt-1 text-md text-secondary-900 max-w-full">{aside.subtitle}</Text>
      </VStack>
      {/* entry detail */}
      {!!aside.detail?.length ? (
        <VStack space="md" className="flex-1 px-2 mt-8 overflow-auto">
          {aside.detail.map((entry, n) => {
            switch (entry.role) {
              case 'checkbox':
                return (
                  <HStack key={`${entry.name}--${n}`} space="md" className="h-8 items-center w-[100%]">
                    {/* TODO(@Milo): add an actual label to the input*/}
                    <Text size="md" className="flex-1">{entry.name}</Text>
                    <Switch key={entry.defaultValue}
                      defaultValue={entry.defaultValue}
                      isDisabled={true}
                      trackColor={{ false: '#767577', true: '#0071DB' }} thumbColor={ '#FFFFFF' }
                    />
                  </HStack>
                );
              case 'list':
                return (
                  <VStack key={`${entry.name}--${n}`} space="md" className="w-[100%]">
                    <HStack space="md" className="h-10 items-center w-[100%] border border-[#BEBEBE]">
                      <Text size="md" className="flex-1 font-[600]">{entry.name}</Text>
                      {entry.context.map((context_entry, k) => (
                        <Button key={'L' + k} variant="link" onPress={context_entry.callback} className="self-end py-2 px-2 border-primary-900">
                          <VStack className="relative">
                            <IconM className='text-primary-900' size={24} name={context_entry.icon.name} />
                          </VStack>
                        </Button>
                      ))}
                    </HStack>
                    {entry.nested.map((nested_entry, m) => {
                      return (
                        <HStack key={`${nested_entry.name}--${n}-${m}`} space="md" className="h-8 items-center w-[100%]">
                          {!!nested_entry.media && (
                            <Image key={nested_entry.media} source={nested_entry.media} resizeMode='cover' fallbackSource={assets_images.placeholderImg} className="w-8 h-8 rounded-[50%]" />
                          )}
                          <Text size="md" className="flex-1">{nested_entry.name}</Text>
                        </HStack>
                      );
                    })}
                  </VStack>
                );
              default:
                return undefined;
            }
          })}
        </VStack>
      ) : (
        <VStack className="flex-1" ></VStack>
      )}
      {/* entry action */}
      {(!!aside.context?.length) && (
        <VStack space="md" className="flex-none my-8">
          {aside.context.map((entry, n) => {
            const action =
              entry.action === 'primary' ? 'bg-primary-900 text-secondary-50' : '';
            const action_text =
              entry.action === 'negative' ? 'text-error-600' :
                entry.action === 'primary' ? 'text-secondary-50' : '';
            return (
              <HStack key={`${entry.name}--${n}`} space="md" className="flex-none items-center w-[100%]">
                {/* FIXME(@Milo): This should be a `Button` or `ExportButton` component */}
                <Pressable onPress={entry.callback} className={` w-[100%] h-10 justify-center items-center rounded-md ${action}`}>
                  <Text size="md" className={action_text}>{entry.name}</Text>
                </Pressable>
              </HStack>
            );
          })}
        </VStack>
      )}
    </VStack>
  );
}
